<template>
  <b-table
    class="releases-table"
    :data="releases"
    :checkable="false">
    <template slot-scope="props">
      <b-table-column field="version" label="Version" centered>
        <router-link
          :to="{ name: 'admin.releases.index.detail', params: { id: props.row.uuid }}">
          {{ props.row.major }}.{{ props.row.minor }}.{{ props.row.build }}
        </router-link>
      </b-table-column>
      <b-table-column field="created" label="Vanilla Package">
        s3://{{ props.row.bucket }}/{{ props.row.key }}
      </b-table-column>
      <b-table-column field="created" label="Created">
        {{ props.row.created | formatEpochDate(gmt) }}
      </b-table-column>
    </template>
  </b-table>
</template>

<script>
import gmt from '@/mixins/gmt';
import releases from '@/mixins/admin/releases';

export default {
  name: 'ReleasesTable',
  mixins: [gmt, releases],
  props: {
    releases: {
      type: Array,
      required: true,
    },
  },
};
</script>
